import axios from 'axios';

const regexUrls = [
  /\/v\d+\/orders/,
  /\/v\d+\/order/,
  /\/v\d+\/skus/,
  /\/v\d+\/shipvias/,
  /\/v\d+\/shipvia/,
  /\/v\d+\/components/,
];

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    const url = error?.config?.url;
    const unauthorised = status === 403 || status === 401;

    if (unauthorised && url && regexUrls.some(regex => regex.test(url))) {
      if (!error.response) {
        error.response = {};
      }
      if (!error.response.data) {
        error.response.data = {};
      }

      error.response.data.message = 'Unauthorized.';
    }

    return Promise.reject(error);
  },
);
